import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

require("jquery-confirm");

import { Auth } from "./Helpers";

import axios from "axios";

axios.defaults.headers.common["x-web-token"] = Auth().getToken();
axios.defaults.headers.common["Content-type"] = "application/json";

import mixins from "./mixins";

Vue.mixin(mixins);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
